export const PILLAR_BOXES_ID = "PillarBoxesId";
